exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-6a430464]{position:relative;overflow-y:auto;height:90vh}.table[data-v-6a430464]{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:auto;margin-top:0;margin-bottom:0;width:100%;min-width:1290px}.table tr td[data-v-6a430464]:last-child{cursor:pointer}.product-details-table[data-v-6a430464]{margin-left:25px}.product-details-table td[data-v-6a430464]{vertical-align:top;width:50%;margin-bottom:3px}", ""]);

// exports
